export default __webpack_public_path__ + "static/img70h-b743702b2cfc0204997b6c836bcd0cb0.jpg";